import { render } from "./AccountAlignment.vue?vue&type=template&id=11a8c5fe&scoped=true"
import script from "./AccountAlignment.vue?vue&type=script&lang=js"
export * from "./AccountAlignment.vue?vue&type=script&lang=js"

import "./AccountAlignment.vue?vue&type=style&index=0&id=11a8c5fe&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a8c5fe"]])

export default __exports__